/* Kit rotator, for sections/shop-bundles.liquid (Shop all's bundles band).

   The section renders the kits as a scrolling row with its dots hidden. This
   script turns a [data-kit-rotator] with 2 or more [data-kit-slide] tiles
   into one tile at a time that advances on its own every data-speed seconds
   (Sam, 2026-09-30: "an auto rotation animation on the right here rather
   than a carousel"). Without it the row stays, so every kit is reachable.

   WCAG 2.2.2 (Pause, Stop, Hide), the same rules as smb-announcement-bar.js:
   - No autoplay under prefers-reduced-motion; the dots still work.
   - Pressing a dot, or keyboard focus entering the stage, STOPS autoplay for
     the rest of the page view.
   - Hovering pauses, and rotation resumes when the pointer leaves.
   - It also waits while the stage is off screen or the tab is hidden, so a
     shopper who scrolls down sees the first kit, not whichever came up.

   A tile that is not showing is `visibility: hidden` (page-shop.css), so its
   link is out of the tab order. A file, not an inline script, for the
   Section Rendering reason in CLAUDE.md ("Bundles"); shopify:section:load
   and :unload set up and tear down a re-rendered band in the theme editor. */
(function () {
  'use strict';
  if (window.smbKitRotator) {
    window.smbKitRotator.initAll(document);
    return;
  }

  var reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  function init(root) {
    if (!root || root.__smbKit) return;
    var slides = root.querySelectorAll('[data-kit-slide]');
    var dotsWrap = root.querySelector('[data-kit-dots]');
    if (slides.length < 2 || !dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('[data-kit-dot]');

    var speed = (parseFloat(root.getAttribute('data-speed')) || 4) * 1000;
    var index = 0;
    var timer = null;
    var stopped = false;
    var hovering = false;
    var visible = true;

    function show(next, from) {
      next = (next + slides.length) % slides.length;
      for (var i = 0; i < slides.length; i++) {
        slides[i].classList.toggle('is-active', i === next);
        slides[i].classList.toggle('is-leaving', i === from && from !== next);
      }
      for (var j = 0; j < dots.length; j++) {
        if (j === next) dots[j].setAttribute('aria-current', 'true');
        else dots[j].removeAttribute('aria-current');
      }
      index = next;
    }

    function canRun() {
      return !stopped && !hovering && visible && !document.hidden && !(reduced && reduced.matches);
    }

    function schedule() {
      clearTimeout(timer);
      timer = null;
      root.toggleAttribute('data-kit-paused', !canRun());
      if (!canRun()) return;
      // Restart the active dot's fill so it runs the full interval.
      var dot = dots[index];
      if (dot) {
        dot.classList.remove('is-filling');
        void dot.offsetWidth;
        dot.classList.add('is-filling');
      }
      timer = setTimeout(function () {
        show(index + 1, index);
        schedule();
      }, speed);
    }

    function stop() {
      stopped = true;
      root.setAttribute('data-kit-stopped', '');
      schedule();
    }

    function onDot(e) {
      var btn = e.target.closest('[data-kit-dot]');
      if (!btn) return;
      var n = parseInt(btn.getAttribute('data-kit-dot'), 10) || 0;
      stop();
      if (n !== index) show(n, index);
    }
    function onEnter() {
      hovering = true;
      schedule();
    }
    function onLeave() {
      hovering = false;
      schedule();
    }
    function onFocus() {
      stop();
    }
    function onVisibility() {
      schedule();
    }

    var io =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              var was = visible;
              visible = entries[0].isIntersecting;
              if (visible && !was && !stopped) show(index, index);
              schedule();
            },
            { threshold: 0.4 },
          )
        : null;

    dotsWrap.addEventListener('click', onDot);
    root.addEventListener('mouseenter', onEnter);
    root.addEventListener('mouseleave', onLeave);
    root.addEventListener('focusin', onFocus);
    document.addEventListener('visibilitychange', onVisibility);
    if (reduced && reduced.addEventListener) reduced.addEventListener('change', onVisibility);
    if (io) io.observe(root);

    dotsWrap.hidden = false;
    root.setAttribute('data-kit-rotating', '');
    root.style.setProperty('--kit-speed', speed + 'ms');
    show(0, 0);
    schedule();

    root.__smbKit = function destroy() {
      clearTimeout(timer);
      dotsWrap.removeEventListener('click', onDot);
      root.removeEventListener('mouseenter', onEnter);
      root.removeEventListener('mouseleave', onLeave);
      root.removeEventListener('focusin', onFocus);
      document.removeEventListener('visibilitychange', onVisibility);
      if (reduced && reduced.removeEventListener) reduced.removeEventListener('change', onVisibility);
      if (io) io.disconnect();
    };
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-kit-rotator]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  function destroyAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-kit-rotator]');
    for (var i = 0; i < roots.length; i++) {
      if (typeof roots[i].__smbKit === 'function') roots[i].__smbKit();
      roots[i].__smbKit = null;
    }
  }

  window.smbKitRotator = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    destroyAll(e.target);
  });
})();
